import request from '@/utils/request'

/**
 * 查询页面
 * @param {Object} params 
 * @returns 
 */
export function listInterfacePage(data) {
  return request({
    url: '/interface_list/list',
    method: 'POST',
    data,
  })
}

/**
 * 查询页面(不分页)
 * @param {Object} params 
 * @returns 
 */
export function allInterfacePage(data) {
  return request({
    url: '/interface_list/allList',
    method: 'POST',
    data,
  })
}

/**
 * 添加界面列表
 * @param {Object} data 
 * @returns 
 */
export function addInterfacePage(data) {
  return request({
    url: '/interface_list/add',
    method: 'POST',
    data,
  })
}


/**
 * 修改页面
 * @param {Object} data 
 * @returns 
 */
export function updateInterfacePage(data) {
  return request({
    url: '/interface_list/update',
    method: 'PUT',
    data,
  })
}


/**
 * 删除页面
 * @param {Object} data 
 * @returns 
 */
export function delInterfacePage(data) {
  return request({
    url: '/interface_list/delete',
    method: 'DELETE',
    data,
  })
}

/**
 * 删除多个页面
 * @param {Object} data 
 * @returns 
 */
 export function batchDelInterfacePage(data) {
  return request({
    url: '/interface_list/batchDelete',
    method: 'DELETE',
    data,
  })
}

